import '../App.scss';
import React, { useState, Component } from 'react';
import TextBox from '../components/Atoms/TextBox'
import TopBarAlt from '../components/Organisms/TopBarAlt'
import List from '../components/Molecules/List'
import Divider from '../components/Atoms/Divider'
import { client } from '../client';
import ReactMarkdown from 'react-markdown'



class NewsDetail extends Component {
  // use a constructor if necessary
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      title: '',
      imageURL: '',
      description: '',
      links: [],
      date: ''
      
    }  
  }

  // //this is where we receive API calls inside components
componentDidMount() {
    client
    //getting id through match-prop that is passed in via react router
    .getEntry(this.props.match.params.id)
    .then(entry => 
      {this.setState({
        data: entry,
        title: entry.fields.newsTitle,
        imageURL: entry.fields.newsImage.fields.file.url,
        description: entry.fields.newsText,
        links: entry.fields.newsLink,
        date: entry.fields.newsDate


      })}
      )
    .catch(err => console.log(err));

}




  render() {

  console.log(this.state.data)

  const {data, title, imageURL, description, links, date} = this.state;

  return (
    <div className="news-page" >
      <TopBarAlt />

      <div className="flex phone-flex-column" style={{minHeight: '500px'}}> 

        <div className="flex-1 br bb flex">
          <img className="w-100 fit-cover"src={`${imageURL}?fm=jpg&fl=progressive`}></img>
        </div>
        
        <div className="flex-1 bb flex wrap flex-column">
          <TextBox cx="w-100 pl-s flex-1" border="bb" firstLevel="h2" secondLevel="i" thirdLevel="p" firstContent={title} secondContent="News" thirdContent={date.substring(0,10)}/>

        <div className="flex flex-3 wrap">
          {/* <p className="flex w-100 pl-m">{description}</p> */}
          <ReactMarkdown className=" w-100 pl-m lh-m">{description}</ReactMarkdown>
          
          <div className="align-self-end">
          {/* Links */}
          {links ? 
            links.map((link, index) => (
              <a className="flex external-link w-100 pb-m pl-m pt-s" href={link} >
                {link}
              </a>
              ) 
              )
              : 
              ""
            }
          </div>
        </div>
        
        </div>
        
      </div>

      {/* <Divider width="100" height="9" content="ALLE NYHEDER" cx="hidden flex items-bottom bb"/> */}

      {/* <List data={data}/> */}


    </div>

  );
};
}

export default NewsDetail;



